<template>
  <div id="app">
    <!--
    <img src="./assets/logo.png">
    -->
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
#app {
  height: 100%;
}

html {
  height: auto;
}

body {
  height: 100%;
}

body {
  font-family: open sans,sans-serif,Helvetica,arial,sans-serif;
  font-size: 14px;
  color: rgba(255,255,255,.7);
  line-height: 23px;
  background-color: #2C2F33;
  margin: 0 auto;

  overflow-x: hidden;
  vertical-align: baseline;
  padding: 0;
  outline: 0;
  border: 0;
}
</style>



// WEBPACK FOOTER //
// src/App.vue